module.exports = __webpack_public_path__ + "static/media/flag-black.ce94c982.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag-black.svg
// module id = 307
// module chunks = 33